import React, { useEffect, useState } from 'react';
import { Dayjs } from 'dayjs';
import type { ParsedUrlQuery } from 'querystring';
import { Divider, Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import { TablePaginationConfig } from 'antd/es/table';
import { useUsers } from 'Contacts/hooks/users';
import { useProducts } from 'Inventory/hooks/products';
import { Product } from 'utils/apiClient/services/inventory/types';
import { InventoryReportTableParams } from 'utils/apiClient/services/reports/types';
import { useLoadInventoryReport } from '../hooks/inventoryReport';
import InventoryReportTable from './InventoryReportTable';

const InventoryReport: React.FC<{
  dateFilter: Dayjs[];
  query: ParsedUrlQuery;
}> = ({ dateFilter, query }) => {
  const [startDate, endDate] = dateFilter;
  const [tableParams, setTableParams] = useState<InventoryReportTableParams>({
    filters: {
      start: startDate,
      end: endDate,
    },
    sorter: { columnKey: 'date', order: 'descend' },
    pagination: {
      current: 1,
      pageSize: 50,
      showSizeChanger: true,
    },
  });
  useEffect(() => {
    setTableParams((prevTableParams) => ({
      ...prevTableParams,
      filters: {
        start: startDate,
        end: endDate,
      },
    }));
  }, [startDate, endDate]);
  const reportsQuery = useLoadInventoryReport({
    tableParams,
    enabled: query._ === '4',
  });
  const users = useUsers({ search: null });
  const products = useProducts({
    filters: { type: 'product' },
    pagination: { current: 1, pageSize: 200 },
    sorter: { columnKey: 'name', order: 'ascend' },
  });

  const handleTableChange = ({
    filters,
    ...params
  }: InventoryReportTableParams) => {
    setTableParams((state: InventoryReportTableParams) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
      sorter: params.sorter,
      pagination: {
        ...(params.pagination as TablePaginationConfig),
      },
    }));
  };
  return (
    <>
      <Row css="padding: 1em 1.2em">
        <Col span={4}>
          <h3 css="margin: 0; line-height: 2em;padding-left: 8px">
            <FormattedMessage defaultMessage="Inventory Report" />
          </h3>
        </Col>
      </Row>
      <Divider css="margin: 0" />
      <div css="padding: 24px">
        <InventoryReportTable
          data={reportsQuery.data?.data}
          users={users.data}
          products={products.data?.results as Array<Product>}
          tableParams={{
            ...tableParams,
            ...(reportsQuery.data !== undefined && {
              pagination:
                reportsQuery.data.total < 10
                  ? false
                  : {
                      ...(tableParams.pagination as TablePaginationConfig),

                      total: reportsQuery?.data.total,
                    },
            }),
          }}
          loading={reportsQuery.isLoading}
          handleTableChange={handleTableChange}
        />
      </div>
    </>
  );
};

export default InventoryReport;
